import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './primitives.css'

/**
 * A single slot in a composed [Pagination Content](/components/pagination-content/)
 * row. Wrap each control — a [Pagination Link](/components/pagination-link/),
 * [Pagination Previous](/components/pagination-previous/), [Pagination Next](/components/pagination-next/)
 * or [Pagination Ellipsis](/components/pagination-ellipsis/) — in its own item.
 *
 * @status draft
 * @category navigation
 * @lightDom true
 *
 * @slot - Default slot for a single pagination control.
 */
@customElement('nord-pagination-item')
export default class PaginationItem extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-pagination-item': PaginationItem
  }
}
